import React from "react";
import abouts1 from "../../asset/images/abouts1.webp";
import abouts2 from "../../asset/images/abouts2.webp";
import abouts3 from "../../asset/images/abouts3.webp";
import abouts4 from "../../asset/images/abouts4.webp";
import "./about.css";
import Lottie from "lottie-react";
import AboutLottie from "../../../public/about_us.json";
import "./aboutresponsive.css"

const AboutStats = () => {
  return (
    <div className="about_stats_container container">
      

      <div className="lottie-hero-about" style={{ display: "flex" }}>
        <div style={{width:"45%"}}>
        <p
        style={{
          color: "#000",
          fontSize: "18px",
          marginBottom: "5px",
          position: "relative",
          width: "fit-content",
        }}
      >
        Who We Are{" "}
        <span
          style={{
            position: "absolute",
            bottom: "0px",
            left: "0px",
            right: "0px",
            height: "2px",
            background:
              "linear-gradient(to right, #006bff, #006bff 50%, #ff8000 50%)",
          }}
        ></span>
      </p>
          <h5 style={{ fontSize: "32px" }}>
            Redefining Learning, Empowering Careers
          </h5>
          <p>
            At Metbrains, we believe that learning should go beyond theory. Our mission is to bridge the gap between knowledge and application by providing practical, mentor-led programs in Data Science, Cyber Security, Data Analytics, and Business Analytics.
          </p>
          <p>
            We are not just an education platform—we are a <strong>career transformation hub</strong> where industry experts guide learners to become professionals ready for today’s job market.
          </p>
        </div>
        <div style={{width:"55%"}}>
          <Lottie className="xnmrph-lottie" onClick={() => { handleNavLinkClick("homecount-xnmrph") }} animationData={AboutLottie} style={{ width: "100%", cursor: "pointer", transition: "all 300ms ease" }} loop={true} />
        </div>
      </div>
      <div className="about_stats_status">
        <div className="about_status">
          <img style={{width:"64px"}} src={"/icons8-graduation-cap-64.png"} alt="" />
          <h2>06</h2>
          <p>Programs</p>
        </div>
        <div className="about_status">
          <img style={{width:"60px"}} src={"/icons8-globe-96.png"} alt="" />
          <h2>31</h2>
          <p>countries Covered</p>
        </div>
        <div className="about_status">
          <img style={{width:"52px"}} src={"/icons8-year-100.png"} alt="" />
          <h2>09+</h2>
          <p>years of experience</p>
        </div>
        <div className="about_status">
          <img style={{width:"60px"}} src={"/icons8-community-96.png"} alt="" />
          <h2>6,744+</h2>
          <p>candidates trained</p>
        </div>
      </div>
    </div>
  );
};

export default AboutStats;
